import { Stack, Typography } from '@mui/material';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import SmsRoundedIcon from '@mui/icons-material/SmsRounded';
import ForwardToInboxRoundedIcon from '@mui/icons-material/ForwardToInboxRounded';
import { Medium, Mediums } from '../../../types/global';
import Badge from './Badge';
import MethodTile from './MethodTile';

interface Props {
  onSelect: (mediums: Medium[]) => void;
}

export default function ChooseStep({ onSelect }: Props) {
  return (
    <Stack alignItems="center" spacing={3} sx={{ width: '100%' }}>
      <Badge />
      <Stack alignItems="center" spacing={0.75} sx={{ width: '100%' }}>
        <Typography
          variant="h1"
          component="h2"
          sx={{
            fontFamily: 'Montserrat, sans-serif',
            letterSpacing: '-0.01em',
            color: 'text.primary',
            textAlign: 'center',
          }}>
          Send a receipt?
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            textAlign: 'center',
            maxWidth: 320,
          }}>
          Where should we send the receipt?
        </Typography>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.25}
        sx={{ width: '100%' }}>
        <MethodTile
          icon={<SmsRoundedIcon sx={{ fontSize: 22 }} />}
          label="Text"
          sublabel="SMS"
          onClick={() => onSelect([Mediums.SMS])}
        />
        <MethodTile
          icon={<EmailRoundedIcon sx={{ fontSize: 22 }} />}
          label="Email"
          sublabel="Inbox"
          onClick={() => onSelect([Mediums.EMAIL])}
        />
        <MethodTile
          icon={<ForwardToInboxRoundedIcon sx={{ fontSize: 22 }} />}
          label="Both"
          sublabel="Text & email"
          onClick={() => onSelect([Mediums.EMAIL, Mediums.SMS])}
        />
      </Stack>
    </Stack>
  );
}
